__turbopack_context__.v({
  "linkIcon": "EventLocationLink-module-scss-module__kdJMBW__linkIcon",
  "locationLink": "EventLocationLink-module-scss-module__kdJMBW__locationLink",
});
